import Crud from '../components/UserGroups/Crud'
import Entity from '../components/UserGroups/Add'

let routes = {
    path: '/users_groups',
    component: resolve => require(['../components/layout/App'], resolve),
    children: [
        {
            path: '/users_groups/add',
            name: 'Novo Grupo de Usuários',
            component: Entity
        },
        {
            path: '/users_groups/edit/:id?',
            name: 'Editar Grupo de Usuários',
            component: Entity
        },
        {
            path: '/users_groups',
            name: 'Grupo de Usuários',
            component: Crud
        },
    ]
};  

export default routes


// WEBPACK FOOTER //
// ./src/router/usergroups.js